import styled from 'styled-components';
import { Card } from '../CompanyPermissionSchemes/styles';
import {
  black,
  blue,
  exactWhite,
  lightGreenSolid,
  white,
} from '../../../../utils/style/colors';

export const ClassListContainer = styled('div')`
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  //max-width: 300px;
  min-width: 208px;
  height: 100%;
  overflow: hidden auto;
  @media only screen and (max-width: 600px) {
    margin: 0;
    padding: 10px 0;
    width: 100%;
    max-width: initial;
  }
`;
export const TermListContainer = styled('div')`
  //background-color: rgb(0, 12, 23);
  display: flex;
  flex-direction: column;
  // color: ${white};
  max-width: 300px;
  min-width: 230px;
  height: 100%;
  overflow: auto;
  @media only screen and (max-width: 600px) {
    margin: 0;
    padding: 3rem 0 10px;
    width: 100%;
    max-width: initial;
  }
`;
export const TermsWrapper = styled('div')`
  display: flex;
  height: 100%;
  overflow: hidden;
`;

export const CreateClassContainer = styled('div')`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  margin: 1rem 0;
`;

export const ClassListContainerHeader = styled('div')`
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
`;

export const SearchUserContainer = styled('div')`
  width: 200px;
  display: flex;
  gap: 10px;
  justify-content: center;
`;

export const EditorWrapper = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  height: calc(100% - 30px);
  position: relative;
  margin: 0;
  @media only screen and (max-width: 769px) {
    margin: 0;
    padding: 10px 0;
  }
`;
export const TermEditorWrapper = styled(EditorWrapper)`
  margin: 1em;
`;
export const ClassOverviewWrapper = styled(Card)`
  display: flex;
  flex-direction: column;
  width: calc(100% - 20px);
  flex-grow: 1;

  overflow: scroll;
  position: relative;
  margin: 10px;
  @media only screen and (max-width: 769px) {
    margin: 0;
    width: 100%;
    padding: 10px 0;
  }
`;

export const PhaseViewerWrapper = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 95%;
  flex-grow: 1;
  height: 100%;
  overflow: scroll;
  padding-top: 50px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  @media only screen and (max-width: 769px) {
    padding: 80px 10px;
  }
`;

export const ClassViewerWrapper = styled(Card)`
  display: block;
  flex-direction: column;
  width: 100%;
  flex-grow: 1;
  height: calc(100% - 20px);
  overflow: scroll;
  padding-top: 20px;
  margin: 0 !important;
  border: 3px solid ${lightGreenSolid};
  position: relative;
  @media only screen and (max-width: 769px) {
    margin: 0;
    padding: 20px 0;
  }
`;

export const ContentContainerRow = styled.div`
  margin: 0.5rem 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  width: 100%;
`;

export const ContentContainerColChildren = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  & button,
  & a {
    width: 12rem;
    align-self: center;
    margin-right: 1rem;
  }
`;

export const ContentHeader = styled.header`
  display: flex;
  align-items: center;
  gap: 1rem;
  height: 4rem;
`;

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
`;

export const DropdownItem = styled.a`
  width: 100%;
  padding: 0.5rem 1rem;
  color: black;
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  overflow: scroll;
  height: 100%;
`;

export const Row = styled.div`
  &:first-child {
    margin-top: 1rem;
    flex-basis: 14rem;
  }

  & > button,
  & > a {
    width: 100%;
    margin: 1rem auto !important;
  }
`;

export const BottomSlider = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  margin-bottom: 2rem;
`;

export const BottomSliderChildren = styled.a`
  width: 100%;
  padding: 0.5rem 1rem;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: ${(props) => props.selected && blue};
`;

export const TopicWrapper = styled.div`
  width: 100%;
  overflow: scroll;
  height: 100%;
  & > div {
    height: 100%;
  }
`;

export const RectangleWrapper = styled.div`
  display: inline-block;
  border-radius: 0.5rem;
  background: ${black};
  color: ${exactWhite};
  margin: 0 0.25rem;
  padding: 0.1rem 0.2rem;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
`;

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 0.5rem;
  overflow: auto;
  border: 1px solid ${black};
  margin-bottom: 0.5rem;

  & > tr:has(th) {
    background: ${black};
    color: ${exactWhite};
  }

  & > tr:has(td) {
    color: ${black};
  }
`;

export const TR = styled.tr`
  &:not(:last-child) {
    border-bottom: 1px solid ${black};
  }
`;

export const TD = styled.td`
  width: ${(props) => (props.isStatus ? '10rem' : '15rem')};
  height: 100%;
  padding: 0.5rem;

  &:last-child {
    width: auto;
    flex: 1;
    border-right: none;
  }
`;

export const TH = styled.th`
  width: ${(props) => (props.isStatus ? '10rem' : '15rem')};
  padding: 0.5rem;

  &:last-child {
    width: auto;
  }
`;
